module.exports = "<div class=\"footer-inner\">\n\t<div class=\"footer-content\">\n\t\t<span class=\"bigger-120\">\n\t\t\tHKAF &copy; 2017\n\t\t</span>\n\t</div>\n</div>"


//////////////////
// WEBPACK FOOTER
// ./src/widgets/footer/footer.html
// module id = 530
// module chunks = 0